import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import AddEmail from './AddEmail';
import EmailsList from './EmailsList';
import useFetchNotificationEmails from './useFetchNotificationEmails';
import { saveNotificationEmails, deleteNotificationEmail } from '../../../Services';

function EmailContainer() {
  const [addNotificationEmailLoading, setAddNotificationEmailLoading] = useState(false);
  const [notificationEmails, setNotificationEmails] = useState([]);
  const { response, error, isLoading } = useFetchNotificationEmails();

  const handleAddEmail = (email) => {
    setAddNotificationEmailLoading(true);
    saveNotificationEmails(email).then((res) => {
      if (res.status === 'success') {
        const newEmails = [...notificationEmails, { email }];
        setNotificationEmails(newEmails);
        setAddNotificationEmailLoading(false);
        toast.success('Added Successfully');
      } else {
        toast.error('Email Already Exist');
        setAddNotificationEmailLoading(false);
      }
    }).catch((err) => {
      setAddNotificationEmailLoading(false);
    });
  };

  const handleDeleteEmail = (email) => {
    deleteNotificationEmail(email).then((res) => {
      console.log('deleted successfully');
      const newEmails = notificationEmails.filter(item => item.email !== email);
      setNotificationEmails(newEmails);
    }).catch((err) => {
      console.log('err ');
    });
  };

  useEffect(() => {
    const data = response ? response.emails : [];
    setNotificationEmails(data);
  }, [response]);

  return (
    <>
      <h3> Notification Config </h3>
      <AddEmail handleAddEmail={handleAddEmail} loadingStatus={addNotificationEmailLoading} />
      {isLoading ? <>...loading </>
        : <EmailsList handleDeleteEmail={handleDeleteEmail} list={notificationEmails} />
      }

    </>
  );
}
export default EmailContainer;
